import { ReactElement } from "react";
import { UserInfoModel } from "app/model/ua/user-info";
import { useAppSelector } from "app/store/hook";
import { UserInfoUtil } from "app/utils/userInfoUtil";
import { AuthConstant } from "app/constants/authConstant";
import DbAdminBase from "app/pages/db/admin/DbAdminBase";
import DbBrokerBase from "app/pages/db/broker/DbBrokerBase";
import DbUserCustom from "app/pages/db/user/DbUserCustom";
import DbUserMobileCustom from "app/pages/db/user/DbUserMobileCustom";
import DbR005Base from "app/pages/db/r005/DbR005Base";

export default function DbBase(): ReactElement {
  const userInfo: UserInfoModel = useAppSelector((state) => state.userInfo.userInfo);
  const isMobileView: boolean = useAppSelector((state) => state.layout.sideBarShowSmall);

  return (
    <>
      {userInfo?.userId && (
        UserInfoUtil.isAdmin(userInfo) && <DbAdminBase />
      )}
      {userInfo?.userId && UserInfoUtil.hasRole(userInfo, AuthConstant.R001) && (
        UserInfoUtil.hasRole(userInfo, AuthConstant.R005) ? (
          <DbR005Base />
        ) : (
          isMobileView ? <DbUserMobileCustom /> : <DbUserCustom />
        )
      )}
      {userInfo?.userId && (
        UserInfoUtil.hasRole(userInfo, AuthConstant.R002) && <DbBrokerBase />
      )}
    </>
  );
}